import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KPortalCard";
var classes = {
    actionArea: "".concat(PREFIX, "-actionArea"),
    image: "".concat(PREFIX, "-image"),
    content: "".concat(PREFIX, "-content"),
    contentHeader: "".concat(PREFIX, "-contentHeader")
};
var StyledKPortalCard = styled(Card)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            boxShadow: theme.shadows[5]
        },
        _b["& .".concat(classes.actionArea)] = {
            display: "grid",
            gridTemplateRows: "auto minmax(30%, min-content)",
            gridTemplateColumns: "1fr",
            gridTemplateAreas: ' "image" "content"',
            cursor: "pointer",
            height: "100%",
            width: "100%"
        },
        _b["& .".concat(classes.image)] = {
            gridArea: "image",
            height: "100%",
            width: "100%"
        },
        _b["& .".concat(classes.content)] = {
            gridArea: "content",
            alignSelf: "start",
            padding: theme.spacing(2)
        },
        _b["& .".concat(classes.contentHeader)] = {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between"
        },
        _b);
});

export { classes, StyledKPortalCard as default };
//# sourceMappingURL=index.styled.js.map
